import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./SlideIn.module.css";

const directionBetween = (from, to) =>
  from === to ? null : to > from ? "forward" : "back";

const useSlideDirection = (position) => {
  const [last, setLast] = React.useState({ position, direction: null });

  if (last.position !== position) {
    setLast({ position, direction: directionBetween(last.position, position) });
  }

  return last.position === position
    ? last.direction
    : directionBetween(last.position, position);
};

/* Remounted per position, so the entrance plays on every change. */
const SlideIn = React.forwardRef(
  ({ position, as: Component = "div", className, children, ...rest }, ref) => {
    const direction = useSlideDirection(position);

    return (
      <Component
        key={position}
        ref={ref}
        className={clsx(css.root, className)}
        data-direction={direction ?? undefined}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

SlideIn.displayName = "SlideIn";

SlideIn.propTypes = {
  position: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SlideIn;
